module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/3-6f82722b3d173115f04808e8e86777da.svg";